import React from 'react';
import cn from 'classnames';

import { Icons } from '@icons/icons';

import { ISelectValueProps } from './SelectValue.types';

import Tooltip from '../../../Tooltip';

import './SelectValue.scss';

const SelectValue: React.FC<ISelectValueProps> = ({
	option,
	removeHandler,
	isOverflow,
	selectItemRef,
	readOnly,
}) => {
	const tooltipContent = option?.tooltipText || option?.label;
	const isDisabledTooltip = !option?.tooltipText && !isOverflow;
	const removeOption = () => removeHandler(option);
	const isEnabledSelectedChips = !option?.isFixed && !option?.disabled && !readOnly;

	return (
		<Tooltip
			content={tooltipContent as string}
			isDisabled={isDisabledTooltip}
			placement='top'
		>
			<div
				ref={selectItemRef}
				className={cn('f5gChipsSelectItemContainer', { 'f5gChipsDisabledSelectChips': !isEnabledSelectedChips })}
				style={{ overflow: isOverflow ? 'hidden' : 'visible' }}
			>
				<div className='f5gChipsSelectItemTitle'>{option?.label}</div>
				{isEnabledSelectedChips && (
					<div
						className='f5gChipsSelectItemClearIcon'
						onClick={removeOption}
					>
						{Icons.clearGroupSelect()}
					</div>
				)}
			</div>
		</Tooltip>
	);
};

export default SelectValue;
